

export const LEFT_OF_SINK = {
  id: "4-prep",
  name: "Home Prep Station",
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: -0.11253661511255864,
    pitch: 0.5420497670333191,
    fov: 1.269422238580873,
  },
  linkHotspots: [
    {
      yaw: 1.6296157521407437,
      pitch: 0.2970314266689833,
      rotation: 0,
      target: "3-nook",
    },
    {
      yaw: 2.341409178938931,
      pitch: 0.21951550950758048,
      rotation: 6.283185307179586,
      target: "1-range",
    },
    {
      yaw: -2.9155813842740894,
      pitch: 0.41741136115862787,
      rotation: 4.71238898038469,
      target: "2-island",
    },
    {
      yaw: -2.5602302814673266,
      pitch: 0.272335000326283,
      rotation: 7.853981633974483,
      target: "5-dining",
    },
    {
      yaw: 2.673097872183015,
      pitch: 0.052073788144474165,
      rotation: 14.922565104551524,
      target: "0-init",
    },
  ],
  infoHotspots: [
    {
      yaw: -0.27741122229086557,
      pitch: 0.4612534285315171,
      title: `Cut &amp; Store Containers`,
      subhead: `Cut &amp; Store Containers`,
      text: `
    <ul>
      <li><b>#100677</b></li>
      <li>
        <b>USD</b>
        $30 |
        <b>CAD</b>
        $40
      </li>
      <li>3-year guarantee</li>
      <li>Dishwasher-safe | Freezer-safe</li>
      <li>
          Includes two 5¼'' x 7" x 3" (13.5 cm x 18 cm x 7.5 mm) containers and two cutting board lids.
      </li>
      <li>Each container holds 4 cups (1 L).</li>
      <li>
        These are the ultimate 2-in-1 kitchen storage containers. Outfitted with
        lids that double as cutting boards, you can use these durable containers
        to cut and store your food.
      </li>
      <li>They stack to save you counter and fridge space.</li>
      <li>
        <b>Great for:</b>
        meal prep, storing leftovers, snacks, and more.
      </li>
    </ul>
  `,
      images: [
        `<img width="640" alt="containers-01.jpeg" src="https://pamperedchef.widen.net/content/whvyla6lgp/jpeg/containers-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="containers-02.jpeg" src="https://pamperedchef.widen.net/content/n8mqvawpjy/jpeg/containers-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
      ],
      videos: [
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/a3swvbznk3/video-product-ss22-cut-and-store-containers-loop-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
      ],
    },
    {
      yaw: 0.6364725804295972,
      pitch: 0.6988531379907759,
      title: `Stainless Steel Colander`,
      subhead: `5-qt. (4.7-L) Stainless Steel Colander`,
      text: `
    <ul>
      <li><b>#100692</b></li>
      <li>
        <b>USD</b>
        $45 |
        <b>CAD</b>
        $55
      </li>
      <li>3-year guarantee </li>
      <li>Dishwasher-safe</li>
      <li>12" (30-cm) with handles; 6" (15 cm) tall.</li>
      <li>Durable stainless steel with silicone and plastic handles.</li>
      <li>
        Perforated hole design is ideal for draining cooked pasta quickly.
      </li>
      <li>
        Foot ring elevates the colander for easier draining and won't scratch
        the kitchen sink.
      </li>
      <li>
        Soft-grip handles make this colander comfortable to hold while draining.
      </li>
      <li>
        <b>Great for:</b>
        apples, potatoes, cooked pasta, and more.
      </li>
    </ul>
  `,
      images: [
        `<img width="640" alt="colander-01.jpeg" src="https://pamperedchef.widen.net/content/rids3czt9z/jpeg/colander-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img height="640" alt="colander-02.jpeg" src="https://pamperedchef.widen.net/content/sv4uc0ofem/jpeg/colander-02.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
      ],
      videos: [
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/yas15dztfl/video-product-ss22-stainless-steel-colander-loop-virtual-kitchen-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
      ],
    },
    {
      pitch: 0.4347506402135508,
      yaw: -1.0781170434380662,
      class: "hidden-icon",
      singlePaneModal: true,
      title: `Golden Spoon #2`,
      text: `<img width="640" alt="spring-golden-spoon-02.jpeg" src="https://pamperedchef.widen.net/content/pjs4lhfqf8/jpeg/spring-golden-spoon-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
    },
  ],
};
